<div class="header" translate="m/task-process/send_and/ask-for-help"></div>
<ion-content>
  <ion-item>
    <ion-label position="floating" translate="m/task-process/help-requests/placeholder"></ion-label>
    <ion-textarea [formControl]="messageControl" rows="4" data-testid="ask-for-help-message"></ion-textarea>
  </ion-item>
</ion-content>
<div class="footer">
  <ion-button (click)="ok(messageControl.value)" [disabled]="messageControl.invalid" translate="ok"> </ion-button>
  <ion-button (click)="cancel()" fill="outline" translate="cancel"> </ion-button>
</div>
